import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet';

const HeroSection = ({ startTimer, heroVideoUrl }) => {
  const slides = [
    {
      type: "video",
      video: "https://res.cloudinary.com/dgqu4ohbw/video/upload/v1740037714/bef3dc38-4081-4ec1-8dc5-b45aa1d85127_dr3yrw.mov",
      text: "Experience the Peak Vibes",
      banter: "Step into the buzz of TheGrillShack at peak hours and feel the energy!",
      route: "/menu",
      alt: "Busy restaurant atmosphere video"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687200/IMG_2024_xtkcax.png",
      text: "Start Your Day Right",
      banter: "From fluffy pancakes to crispy bacon, our breakfast spread will make your morning legendary! ☀️",
      route: "/menu/breakfast",
      alt: "Delicious breakfast spread with pancakes and bacon"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687220/IMG_2028_r3j49p.png",
      text: "Taste Nigerian Breakfast",
      banter: "Hot, fresh Pap and Akara - The authentic Nigerian breakfast that feels like a warm hug from home! 🇳🇬",
      route: "/menu/breakfast",
      alt: "Traditional Nigerian breakfast with pap and akara"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687244/IMG_4155-Edit_rkwz9e.jpg",
      text: "Savor Yam & Egg",
      banter: "Perfectly diced yam served with rich egg sauce - A Nigerian breakfast classic that never disappoints! 🍳",
      route: "/menu/breakfast",
      alt: "Nigerian yam and egg sauce breakfast"
    },
    {
      type: "image",
      image: "https://media.istockphoto.com/id/1388097969/photo/egusi-ogbonno-vegetable-and-afang-soup-with-pounded-yam-and-eba-garri.jpg?s=612x612&w=0&k=20&c=BVHztgr0tiuPh67ZmozIfY9huk92-Dqq0uOcawEhLBU=",
      text: "Explore Nigerian Soups",
      banter: "From rich Egusi to hearty Ogbono - Our Nigerian soups will transport you straight to mama's kitchen! 🥘",
      route: "/menu/nigerian-soups",
      alt: "Traditional Nigerian soups"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687250/IMG_7010_qbsjpz.jpg",
      text: "Bite into Burgers",
      banter: "Juicy, stacked, and packed with flavor - Our burgers are what dreams are made of! 🍔",
      route: "/menu/sandwich",
      alt: "Gourmet burger with all the toppings"
    },
    {
      type: "image",
      image: "https://media.istockphoto.com/id/1217760999/photo/grilled-chicken-breasts-with-thyme-garlic-and-lemon-slices-on-a-grill-pan-close-up.jpg?s=612x612&w=0&k=20&c=a0g01BhrUoTs0xIni02rSWbEB6rdftB89F-ON3Ida5w=",
      text: "Sizzle at Our Grills",
      banter: "Chicken Republic and TFC are shaking! Our grilled chicken is so juicy, even their mascots are sneaking in for a bite!",
      route: "/menu/grills",
      alt: "Perfectly grilled chicken"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687236/IMG_4161_yltbde.jpg",
      text: "FREE Jollof with Grills",
      banter: "Get a FREE side of our legendary jollof rice with ANY protein from our grill section! 🍗🍚 Limited time offer!",
      route: "/menu/grills",
      alt: "Grilled chicken with jollof rice combo",
      isSpecialOffer: true
    },
    {
      type: "image",
      image: 'https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687093/chicken_shawarma_td8hzl.jpg',
      text: "Explore Our Shawarma",
      banter: "Our shawarmas are so legendary, they have their own fan club! Warning: May cause spontaneous happy dances. 🕺",
      route: "/menu/shawarma",
      alt: "Fresh chicken shawarma wrap"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1740222214/IMG_2021_jnqycq_phgwpg.jpg",
      text: "Indulge in Pastries",
      banter: "Pastries so good, your gym trainer will understand. Trust us, we've seen it happen! 🍪",
      route: "/menu/pastry",
      alt: "Freshly baked pastries assortment"
    },
    {
      type: "image",
      image: "https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687265/IMG_4282-Edit_srloaw.jpg",
      text: "Refresh with Smoothies",
      banter: "Smoothies so fresh, they make Lagos traffic feel like a breeze! No cap! 🌪️",
      route: "/menu/smoothies",
      alt: "Colorful fresh fruit smoothies"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (startTimer && isAutoPlaying) {
      const timer = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [startTimer, slides.length, isAutoPlaying]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const handleKeyPress = (e, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      goToSlide(index);
    }
  };

  return (
    <>
      <Helmet>
        <title>The Grill Shack - Nigerian & International Cuisine | Lagos's Premier Restaurant</title>
        <meta name="description" content="Experience the best of Nigerian and international cuisine at The Grill Shack. From traditional breakfasts to gourmet burgers, grilled specialties, and authentic Nigerian soups." />
        <meta name="keywords" content="Nigerian restaurant, Lagos restaurant, pap and akara, yam and egg sauce, Nigerian soups, grilled chicken, shawarma, breakfast, burgers" />
        <meta property="og:title" content="The Grill Shack - Nigerian & International Cuisine" />
        <meta property="og:description" content="Lagos's premier destination for Nigerian and international cuisine. Enjoy traditional breakfasts, grilled specialties, and authentic Nigerian soups." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://res.cloudinary.com/dgqu4ohbw/image/upload/v1739687093/chicken_shawarma_td8hzl.jpg" />
        <link rel="canonical" href="https://thegrillshack.ng" />
      </Helmet>

      <div className="hero-section flex flex-col h-screen bg-black" role="region" aria-label="Featured menu items carousel">
        <div
          className="banner w-full bg-red-600 text-white py-2 overflow-hidden"
          role="banner"
          style={{
            background: 'linear-gradient(45deg, #dc2626, #ef4444, #dc2626)',
            backgroundSize: '200% 200%',
            animation: 'gradient 3s ease infinite'
          }}
        >
          <div
            className="banner-text whitespace-nowrap text-lg font-bold"
            style={{
              animation: 'marquee 15s linear infinite',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
            aria-live="polite"
          >
            🔥 SPECIAL OFFER: Every protein from our grill comes with a FREE side! Order now! 🍚
          </div>
        </div>

        <div className="flex-grow relative" role="region" aria-roledescription="carousel">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 ${currentIndex === index ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
                } transition-opacity duration-1000`}
              role="group"
              aria-roledescription="slide"
              aria-label={`Slide ${index + 1} of ${slides.length}: ${slide.text}`}
            >
              {/* Mobile Layout */}
              <div className="md:hidden relative h-full">
                {slide.type === "video" ? (
                  <video
                    className="absolute inset-0 w-full h-full object-cover"
                    src={slide.video}
                    autoPlay
                    loop
                    muted
                    playsInline
                    aria-label={slide.alt}
                  />
                ) : (
                  <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${slide.image})` }}
                    role="img"
                    aria-label={slide.alt}
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

                <div className="absolute inset-x-0 bottom-0 p-6 space-y-4 bg-black/50 backdrop-blur-sm">
                  <h2 className={`text-3xl font-bold text-white ${slide.isSpecialOffer ? 'animate-bounce' : ''}`}>
                    <span className="text-red-500">{slide.text.split(' ')[0]}</span>{' '}
                    {slide.text.split(' ').slice(1).join(' ')}
                  </h2>

                  <p className="text-sm text-gray-200 line-clamp-2">
                    {slide.banter}
                  </p>

                  <Link
                    to={slide.route}
                    className={`inline-flex items-center px-6 py-3 ${slide.isSpecialOffer ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-red-600 hover:bg-red-700'
                      } text-white font-semibold rounded-lg shadow-lg transition-all duration-300`}
                    aria-label={`Order ${slide.text}`}
                  >
                    Order Now
                    <ArrowRight size={20} className="ml-2" />
                  </Link>
                </div>
              </div>

              {/* Desktop Layout */}
              <div className="hidden md:flex flex-row h-full">
                <div className="w-1/2 flex items-center justify-center p-8 bg-black relative z-10">
                  <div className="max-w-xl">
                    <div className="w-24 h-1 bg-red-600 mb-6"></div>

                    <h2 className={`text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight ${slide.isSpecialOffer ? 'animate-bounce' : ''
                      }`}>
                      <span className="text-red-500">{slide.text.split(' ')[0]}</span>{' '}
                      {slide.text.split(' ').slice(1).join(' ')}
                    </h2>

                    <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                      {slide.banter}
                    </p>

                    <Link
                      to={slide.route}
                      className={`group inline-flex items-center px-8 py-4 ${slide.isSpecialOffer ? 'bg-red-500 hover:bg-red-600' : 'bg-red-600 hover:bg-red-700'
                        } text-white font-semibold rounded-lg shadow-lg transition-all duration-300`}
                      aria-label={`Order ${slide.text}`}
                    >
                      Order Now
                      <ArrowRight
                        size={24}
                        className="ml-3 transition-transform duration-300 group-hover:translate-x-2"
                      />
                    </Link>
                  </div>
                </div>

                <div className="w-1/2 relative overflow-hidden">
                  {slide.type === "video" ? (
                    <video
                      className="w-full h-full object-cover"
                      src={slide.video}
                      autoPlay
                      loop
                      muted
                      playsInline
                      aria-label={slide.alt}
                    />
                  ) : (
                    <div
                      className="w-full h-full transform transition-transform duration-[2s] hover:scale-110"
                      style={{
                        backgroundImage: `url(${slide.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                      role="img"
                      aria-label={slide.alt}
                    >
                      <div className="absolute inset-0 bg-gradient-to-l from-transparent to-black opacity-30"></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

          {/* Carousel Controls */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2" role="tablist">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => goToSlide(i)}
                onKeyPress={(e) => handleKeyPress(e, i)}
                className={`h-1 rounded-full transition-all duration-300 ${i === currentIndex ? "w-8 bg-red-600" : "w-2 bg-gray-600"
                  }`}
                role="tab"
                aria-selected={i === currentIndex}
                aria-label={`Go to slide ${i + 1}`}
                tabIndex={0}
              />
            ))}
          </div>
        </div>
      </div>

      <style>
        {`
    @keyframes marquee {
      0% { transform: translateX(100%); }
      100% { transform: translateX(-100%); }
    }
    @keyframes gradient {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `}
      </style>

    </>
  );
};

export default HeroSection;